import { Component, OnInit } from "@angular/core";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { MatDialog } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute } from "@angular/router";
import { AccountService } from "src/app/data-access-layer/account/account.service";
import { DatapointsPageStateService } from "../../dataset/datapoints/datapoints-page-state.service";
import { Dataset } from "../../model/dataset/dataset";
import { Account } from "../../model/account/account";
import { UserStateService } from "src/app/auth/user-state-service";
import { forkJoin } from "rxjs";
import { OverlaysService } from "src/app/data-access-layer/global-overlays/overlays.service";
import { map } from "rxjs/operators";
import { NotifService } from "src/app/core/notification/notif.service";

@Component({
    selector: "map-account-external-overlays",
    templateUrl: "./account-external-overlays.component.html",
    styleUrls: ["./account-external-overlays.component.scss"],
})
export class AccountExternalOverlaysComponent implements OnInit {
    isTableDataLoading: boolean;
    allSelected: boolean;
    tessadataOverlays: Dataset[];
    accountTessadataOverlays: Dataset[];
    accountId: number;
    currentAccount: Account;
    currentDisplayedColumns: string[] = ["Name", "DatasetID", "Actions"];
    breadCrumbs = ["Home", "Accounts", "Settings"];
    overlaysDataSource: MatTableDataSource<Dataset>;
    isSuperadmin: boolean;

    get componentName() {
        return this.constructor.name;
    }

    constructor(
        private readonly overlayService: OverlaysService,
        private readonly route: ActivatedRoute,
        private readonly datapointsPageStateService: DatapointsPageStateService,
        private readonly accountService: AccountService,
        private readonly userStateService: UserStateService,
        private readonly notifService: NotifService
    ) {
        this.tessadataOverlays = [];
        this.accountTessadataOverlays = [];
    }

    ngOnInit() {
        this.accountId = +this.route.snapshot.paramMap.get("accountId");
        this.init();
        this.isSuperadmin = this.userStateService.isSuperadmin;
    }

    private init(): void {
        if (this.accountId) {
            this.accountService
                .getAccount(this.accountId)
                .subscribe((account) => {
                    this.currentAccount = account;
                    this.datapointsPageStateService.activeAccount = account;
                });
            this.fetchOverlays();
            if (!this.userStateService.isSuperadmin) {
                this.currentDisplayedColumns.splice(
                    this.currentDisplayedColumns.indexOf("Actions"),
                    1
                );
            }
        }
    }

    fetchOverlays(): void {
        forkJoin(
            this.overlayService.getAllTessadataOverlays(),
            this.overlayService.getAccountTessadataOverlays(this.accountId)
        ).subscribe(
            ([tessadataOverlays, accountTessadataOverlays]: [
                Dataset[],
                Dataset[]
            ]) => {
                this.tessadataOverlays = tessadataOverlays;
                this.accountTessadataOverlays = accountTessadataOverlays;
                if (this.userStateService.isSuperadmin) {
                    this.overlaysDataSource = new MatTableDataSource(
                        tessadataOverlays
                    );
                } else if (
                    this.userStateService.isAccountAdmin(this.accountId)
                ) {
                    this.overlaysDataSource = new MatTableDataSource(
                        accountTessadataOverlays
                    );
                }
                this.overlaysDataSource.data.forEach((overlay) => {
                    overlay.hasOverlay = this.accountHasOverlay(
                        overlay.datasetId
                    );
                });
                this.checkForAllSelected();
            }
        );
    }

    accountHasOverlay(overlayId: string): boolean {
        const overlay = this.accountTessadataOverlays.find(
            (accountOverlay) => accountOverlay.datasetId === overlayId
        );
        return overlay ? true : false;
    }

    applyAll() {
        let datasetIDs = [];
        this.overlaysDataSource.data.forEach((overlay) => {
            if (overlay.hasOverlay) {
                datasetIDs.push(overlay.datasetId);
            }
        });
        this.overlayService
            .assignExternalOverlaysToAccount({
                accountID: this.accountId,
                datasetIDs,
            })
            .subscribe(() => {
                this.init();
                this.notifService.success("Changes applied.");
            });
    }

    applyFilter(filterValue: string): void {
        this.overlaysDataSource.filter = filterValue.trim().toLowerCase();
    }

    toggleOverlay(event: boolean, overlay: Dataset) {
        if (event) {
            this.asssignOverlay(overlay);
        } else {
            this.unasssignOverlay(overlay);
        }
        this.checkForAllSelected();
    }

    checkForAllSelected() {
        let overlayUnselected;
        overlayUnselected = this.overlaysDataSource.data.find(
            (overlay) => overlay.hasOverlay === false
        );
        !overlayUnselected
            ? (this.allSelected = true)
            : (this.allSelected = false);
    }

    // updateAccountOverlays(): void {
    //     this.overlayService.getAccountTessadataOverlays(this.accountId).subscribe(accountTessadataOverlays => this.accountTessadataOverlays = accountTessadataOverlays);
    // }

    asssignOverlay(overlay: Dataset): void {
        this.accountTessadataOverlays.push(overlay);
        overlay.hasOverlay = true;
        // this.overlayService.getAccountsForExtrnalOverlay(overlay.datasetId)
        //     .pipe(
        //         map(accounts => accounts.map(account => account.id))
        //     )
        //     .subscribe(accountIds => {
        //         accountIds.push(this.accountId);
        //         this.overlayService.assignAccountsToExternlOverlay(accountIds, overlay.datasetId).subscribe((res) => {
        //             this.updateAccountOverlays();
        //             this.notifService.success('Overlay applied');
        //             },
        //             (err) => {
        //             // here it's a 500 internal error occur
        //             console.log(err);
        //             });
        //     });
    }

    unasssignOverlay(overlay: Dataset): void {
        this.accountTessadataOverlays = this.accountTessadataOverlays.filter(
            (accountOverlay) => accountOverlay.datasetId !== overlay.datasetId
        );
        overlay.hasOverlay = false;
        // this.overlayService.getAccountsForExtrnalOverlay(overlay.datasetId)
        //     .pipe(
        //         map(accounts => accounts.map(account => account.id))
        //     )
        //     .subscribe(accountIds => {
        //         accountIds = accountIds.filter(accountId => accountId !== this.accountId);
        //         this.overlayService.assignAccountsToExternlOverlay(accountIds, overlay.datasetId).subscribe(() => this.updateAccountOverlays());
        //     });
    }

    toggleAll() {
        this.overlaysDataSource.data.forEach((overlay) => {
            overlay.hasOverlay = this.allSelected;
        });
    }
}
